// ============================================================================
// Shared page container: wide dashboard feel with consistent max-width and padding.
// Use for owner/team property pages, list pages, and app content (not landing).
// ============================================================================

import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface PageContainerProps {
  children: ReactNode;
  className?: string;
  /** If true, no horizontal padding (e.g. when child needs full bleed). */
  noPadding?: boolean;
}

const CONTAINER_BASE = "w-full max-w-[1400px] mx-auto min-w-0";
const CONTAINER_PADDING = "px-4 md:px-6 lg:px-8";
const CONTAINER_CLASS = `${CONTAINER_BASE} ${CONTAINER_PADDING}`;

export function PageContainer({ children, className, noPadding }: PageContainerProps) {
  return (
    <div
      className={cn(
        CONTAINER_BASE,
        !noPadding && CONTAINER_PADDING,
        className
      )}
    >
      {children}
    </div>
  );
}

export const pageContainerClass = CONTAINER_CLASS;
